type Validator = (str: string) => string;

export default function optional(validator: Validator): Validator {
  return (str: string) => (str === "" ? "" : validator(str));
}
